import { Entity } from '@nx-smartmonkey/shared/domain';
import { RouteStatus } from './RouteStatus';

export interface FlatRouteDTO {
  id: string;
  name: string;
  vehicle_id?: string;
  label?: string;
  plan_id?: string;
  plan_label?: string;
}

interface FlatRouteProps {
  vehicle_id?: string;
  label?: string;
  plan_id?: string;
  plan_label?: string;
  plan_execution_date?: Date;
  status?: RouteStatus;
}

export class FlatRoute extends Entity<FlatRouteProps> {
  get id(): string {
    return this._id!;
  }
  get plan_id(): string | undefined {
    return this.props.plan_id;
  }

  get vehicle_id(): string | undefined {
    return this.props.vehicle_id;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  get plan_label(): string | undefined {
    return this.props.plan_label;
  }
  get plan_execution_date(): Date | undefined {
    return this.props.plan_execution_date;
  }
  get status(): RouteStatus | undefined {
    return this.props.status;
  }

  private constructor(props: FlatRouteProps, id: string) {
    super(props, id);
  }

  static create(props: FlatRouteProps, id: string) {
    return new FlatRoute(props, id);
  }
}
